import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import mailReducer from './slices/mail';
import chatReducer from './slices/chat';
import blogReducer from './slices/blog';
import userReducer from './slices/user';
import productReducer from './slices/product';
import calendarReducer from './slices/calendar';
import kanbanReducer from './slices/kanban';
import transactionReducer from './slices/transaction';
import taskReducer from './slices/task';
import caseReducer from './slices/case';
import merchantReducer from './slices/merchant';
import merchantMetricsReducer from './slices/merchantMetrics';
import smsWalletReducer from './slices/smsWallet';
import smsCampaignReducer from './slices/smsCampaign';
import adminAccountReducer from './slices/adminAccount';
import subscriptionPlanReducer from './slices/subscriptionPlan';
import smsOverageBillingReducer from './slices/smsOverageBilling';
import industryReducer from './slices/industry';
import appSettingsReducer from './slices/appSettings';
import auditCampaignReducer from './slices/auditCampaign';
// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: []
};

const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout']
};

const rootReducer = combineReducers({
  case: caseReducer,
  task: taskReducer,
  transaction: transactionReducer,
  merchant: merchantReducer,
  merchantMetrics: merchantMetricsReducer,
  smsWallet: smsWalletReducer,
  smsCampaign: smsCampaignReducer,
  adminAccount: adminAccountReducer,
  subscriptionPlan: subscriptionPlanReducer,
  smsOverageBilling: smsOverageBillingReducer,
  industry: industryReducer,
  appSettings: appSettingsReducer,
  auditCampaign: auditCampaignReducer,
  mail: mailReducer,
  chat: chatReducer,
  blog: blogReducer,
  user: userReducer,
  calendar: calendarReducer,
  kanban: kanbanReducer,
  product: persistReducer(productPersistConfig, productReducer)
});

export { rootPersistConfig, rootReducer };
